import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Spinner } from 'react-bootstrap-5';
import LogoVerifyCard from './logo_verify_card';
import ReplaceLogoModal from './replace_logo_modal';
import { fetchDefaults } from './api';

export default function LogoVerifyList({ companyId, logos }) {
  const [logoDefaults, setLogoDefaults] = useState([]);
  const [loading, setLoading] = useState(true);
  const [replaceModalData, setReplaceModalData] = useState(null);

  useEffect(() => {
    async function loadDefaults() {
      try {
        const defaults = await fetchDefaults();
        setLogoDefaults(defaults);
      } catch (error) {
        // Failed to load defaults
      } finally {
        setLoading(false);
      }
    }

    loadDefaults();
  }, []);

  const handleShowReplaceModal = (modalData) => {
    setReplaceModalData(modalData);
  };

  const handleHideModal = () => {
    if (replaceModalData?.onCancel) {
      replaceModalData.onCancel();
    }
    setReplaceModalData(null);
  };

  const handleConfirmReplace = async () => {
    if (replaceModalData?.onConfirm) {
      await replaceModalData.onConfirm();
    }
  };

  if (loading) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" role="status" />
        <p className="mt-3">Loading...</p>
      </div>
    );
  }

  return (
    <>
      <Row className="g-4">
        {logos.map(logo => (
          <Col className="d-flex" key={logo.id} lg={3} md={4} sm={6}>
            <LogoVerifyCard
              companyId={companyId}
              logo={logo}
              logoDefaults={logoDefaults}
              onShowReplaceModal={handleShowReplaceModal}
            />
          </Col>
        ))}
      </Row>

      {replaceModalData && (
        <ReplaceLogoModal
          newLogoUrl={replaceModalData.newLogoUrl}
          oldLogoUrl={replaceModalData.oldLogoUrl}
          show={!!replaceModalData}
          onConfirm={handleConfirmReplace}
          onHide={handleHideModal}
        />
      )}
    </>
  );
}

LogoVerifyList.propTypes = {
  companyId: PropTypes.number.isRequired,
  logos: PropTypes.arrayOf(
    PropTypes.shape({
      deleted: PropTypes.bool,
      id: PropTypes.number.isRequired,
      logoUrl: PropTypes.string.isRequired,
      name: PropTypes.string,
      verified: PropTypes.bool
    })
  ).isRequired
};
